"use client";
import { Paragraph, Title } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";

import { cmsUrl, strapiBaseUrl } from "@/app/config";

import { ParallaxWithFramer } from "@/components/Parallax";

import Image from "next/image";
import Animate from "@/components/Animate";
import { useRouter } from "next/navigation";

export default function UnlockExclusive({ homePage }) {
  const router = useRouter();
  return (
    <ParallaxWithFramer speed={0.2} threshold={[0.3, 0.9]}>
      <div className="w-full overflow-hidden bg-system-obsidian relative h-[420px]">
        <div className="relative flex md:justify-start  lg:justify-between h-full">
          <div className="flex p-8 max-w-[1440px] lg:mx-auto h-[420px] md:items-center  lg:pr-[0] ">
            <Animate animation="fadeInUp" className="w-full lg:mt-[40%]">
              <div className="h-[165px]">
                <Title
                  size="xl"
                  className="text-system-disabled w-[220px] md:w-full leading-[38.4px] md:leading-[43.2px] lg:leading-[48px]"
                >
                  {homePage?.ctaHeader || "Unlock exclusive deals"}
                </Title>
                <Paragraph className="text-system-disabled mt-[14px] !text-[19px]">
                  {homePage?.ctaSubHeader || "Save big on the latest electronics – limited time only!"}
                </Paragraph>
                <div className="relative">
                  <Button
                    size="xl"
                    type="submit"
                    className="z-50 mt-[28px] md:mt-[24px] lg:mt-[32px] w-full md:w-[126px]"
                    onClick={() => {
                      const url = homePage?.ctaButtonLink !== null ? `${homePage?.ctaButtonLink}` : "/";
                      router.push(url);
                    }}
                  >
                    {homePage?.ctaButtonText}
                  </Button>
                </div>
              </div>
            </Animate>
          </div>
          <Image
            width={848} // Changed to match lg breakpoint width
            height={420}
            src={`${cmsUrl}${homePage?.image?.url ? homePage?.image?.url : ""}`}
            alt={homePage?.image?.alt}
            className=" md:w-[472px] md:h-[240px] lg:w-[848px] lg:h-[420px] object-contain absolute bottom-0 md:right-0 lg:relative"
            priority // Added priority loading
            loading="eager" // Added eager loading
            quality={75}
          />
        </div>
      </div>
    </ParallaxWithFramer>
  );
}
